export enum B2B_USER_ROLE {
  admin = 'admin',
  manager = 'manager',
  user = 'user',
}

export enum B2B_LEGAL_ENTITY_STATUS {
  create = 'create',
  active = 'active',
  block = 'block',
}
